import React, { useEffect } from "react";
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, Paper, styled, TextField } from "@mui/material";
import axios from "axios";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { IFeeding } from "../../interfaces/Growing/IFeeding";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ConfirmDialog, { confirmDialog } from "../ConfirmDialog";
import { ICrew } from "../../interfaces/ICrew";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
}));


type Props = {
    open: boolean,
    handleClose: () => void,
    feeding: IFeeding | undefined
}

export default function CompleteFeedingDialog(props: Props) {

    const { register, handleSubmit, control, formState: { errors }, reset } = useForm<IFeeding>();

    const [open, setOpen] = React.useState(false);
    const [crews, setCrews] = React.useState<ICrew[]>([]);
    const [acids, setAcids] = React.useState<IAcid[]>([]);
    const [fertilizers, setFertilizers] = React.useState<IFertilizer[]>([]);
    const [chemicals, setChemicals] = React.useState<IChemical[]>([]);

    interface IAcid {
        id: number,
        name: string
    }

    interface IFertilizer {
        id: number,
        name: string
    }

    interface IChemical {
        id: number,
        name: string
    }

    useEffect(() => {
        if (props.feeding != undefined) {
            reset(props.feeding);
        } else {
            reset({});
        }
    }, [props.feeding])



    const onSubmit: SubmitHandler<IFeeding> = data => {
        console.log(data);
        axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Feedings`).then(data => {
            console.log(data);
        });
        let massagedData: IFeeding = {
            id: data.id != undefined ? data.id : 0,
            crewId: data.crewId,
            feedingId: 0,
            pipe: data.pipe,
            fertilizer: data.fertilizer,
            chemical: data.chemical,
            acid: data.acid,
            waterNozzleSize: data.waterNozzleSize,
            percentFertilizer: data.percentFertilizer,
            percentChemical: data.percentChemical,
            percentAcid: data.percentAcid,
            updatedAt: new Date(),
            notes: data.notes,
            isComplete: true
        }
        console.log("MASSAGED DATA", massagedData);
        axios.put(`${process.env.REACT_APP_ENDPOINT}/api/Feedings/${data.id}`, massagedData).then((data) => {
            if (data.status === 200) {
                props.handleClose();
            };
        });
    };

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/Crews`)
            .then(res => {
                setCrews(res.data);
            })

        var exampleAcid: IAcid = {
            id: 1,
            name: "Acid 1"
        }

        setAcids([{ id: 1, name: "Acid 1" }, { id: 2, name: "Acid 2" }, { id: 3, name: "Acid 3" }]);
        setFertilizers([{ id: 1, name: "Fertilizer 1" }, { id: 2, name: "Fertilizer 2" }, { id: 3, name: "Fertilizer 3" }]);
        setChemicals([{ id: 1, name: "Chemical 1" }, { id: 2, name: "Chemical 2" }, { id: 3, name: "Chemical 3" }]);
    }, [])

    const pipes = [
        { id: 1, label: 'Red Pipe' },
        { id: 2, label: 'Blue Pipe' },
        { id: 3, label: 'Plain Pipe' },
    ];



    return (
        <Dialog open={props.open} onClose={props.handleClose} maxWidth='md' fullWidth>
            <DialogTitle>Assign Feeding</DialogTitle>
            <Box component="form">
                <TextField
                    sx={{ display: "none" }}
                    {...register('id')} 
                    required
                    variant="filled"
                    fullWidth
                    id="id"
                    label="ID" />
                <TextField
                    sx={{ display: "none" }}
                    required
                    variant="filled"
                    fullWidth
                    id="id"
                    label="ID" {...register('crewId')} />
                <DialogContent>
                    <Grid container spacing={0} >
                        <Grid item xs={12}>
                            <Item>
                                <TextField
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="pipe"
                                    label="Pipe"
                                    {...register('pipe')} />
                            </Item>
                        </Grid>

                        <Grid item xs={4}>
                            <Item>
                                <TextField
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="fertilizer"
                                    label="Fertilizer"
                                    {...register('fertilizer')} />
                            </Item>
                        </Grid>
                        <Grid item xs={4}>
                            <Item>
                                <TextField
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="chemical"
                                    label="Chemical"
                                    {...register('chemical')} />
                            </Item>
                        </Grid>
                        <Grid item xs={4}>
                            <Item>
                                <TextField
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="acid"
                                    label="Acid"
                                    {...register('acid')} />
                            </Item>
                        </Grid>
                        <Grid item xs={4}>
                            <Item>
                                <TextField
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="fertilizerpercent"
                                    label="Fertilizer Percent"
                                    {...register('percentFertilizer')} />
                            </Item>
                        </Grid>
                        <Grid item xs={4}>
                            <Item>
                                <TextField
                                    {...register('percentChemical')}
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="patchinglistname"
                                    label="Chemical Percent"
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={4}>
                            <Item>
                                <TextField
                                    {...register('percentAcid')}
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="acidPercent"
                                    label="Acid Percent"
                                />
                            </Item>

                        </Grid>
                        <Grid item xs={6}>
                            <Item>
                                <TextField
                                    {...register('waterNozzleSize')}
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="waternozzlesize"
                                    label="Water Nozzle Size" />
                            </Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Item>
                                <TextField
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="feedingnotes"
                                    label="Feeding Notes"
                                    {...register('notes')} />
                            </Item>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button size="large" variant="outlined" onClick={props.handleClose}>Cancel</Button>
                    <Button size="large" variant="contained" color="success" onClick={() => confirmDialog("Are you sure you want to add this feeding?", handleSubmit(onSubmit))}>COMPLETE Feeding</Button>
                </DialogActions>
                <ConfirmDialog />
            </Box>
        </Dialog>
    )
}